import {
    Component
} from '@angular/core';
import {
    ChangeDetectorRef
} from '@angular/core';
import {
    ApperyioHelperService
} from '../../scripts/apperyio/apperyio_helper';
import {
    ApperyioMappingHelperService
} from '../../scripts/apperyio/apperyio_mapping_helper';
import {
    NavController
} from '@ionic/angular';
import {
    ExportedClass as UserService
} from '../../scripts/custom/UserService';
import {
    MAIN_MENU_ICONS
} from '../../../app/scripts/custom/NeurConstants';
import {
    $aio_empty_object
} from '../../scripts/interfaces';
import {
    Input
} from '@angular/core';
import {
    Output
} from '@angular/core';
import {
    EventEmitter
} from '@angular/core';
import {
    ViewChild
} from '@angular/core';
@Component({
    templateUrl: 'MainMenu.html',
    selector: 'component-main-menu',
    styleUrls: ['MainMenu.css', 'MainMenu.scss']
})
export class MainMenu {
    public trip_plan_icon: string;
    public footprints_icon: any;
    public chat_icon: any;
    public explore_icon: any;
    public my_location_icon: any;
    public $a: ApperyioHelperService;
    public $v: {
        [name: string]: any
    };
    public aioChangeDetector: ChangeDetectorRef;
    public currentItem: any = null;
    public mappingData: any = {};
    public __getMapping(_currentItem, property, defaultValue, isVariable?, isSelected?) {
        return this.$aio_mappingHelper.getMapping(this.mappingData, _currentItem, property, defaultValue, isVariable, isSelected);
    }
    public __isPropertyInMapping(_currentItem, property) {
        return this.$aio_mappingHelper.isPropertyInMapping(this.mappingData, _currentItem, property);
    }
    public __setMapping(data: any = {}, keyName: string, propName?: string): void {
        const changes = data.detail || {};
        if (propName) {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes[propName]);
        } else {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes.value);
        }
        this.$aio_changeDetector.detectChanges();
    }
    public __bindedMethods: any = {};
    @Input() public me_icon: any;
    @Output() public menu_select: any = new EventEmitter();
    @Input() public neur_mode: any;
    @Input() public _show_menu: any;
    navigateTo(pageUrl): any {
        /*
const stack = this.naviCtrl.getViews(); // Get the current navigation stack
  // Check if the page exists in the stack
const pageExists = stack.some((page) => page.url === pageUrl);

  if (pageExists) {
    this.naviCtrl.navigateBack(pageUrl);
console.log("back to "+pageUrl)
  } else {
    this.naviCtrl.navigateForward(pageUrl);
console.log("forward to "+pageUrl)
  }
}
*/
    }
    constructor(public Apperyio: ApperyioHelperService, private $aio_mappingHelper: ApperyioMappingHelperService, private $aio_changeDetector: ChangeDetectorRef, public userService: UserService) {
        this.$a = this.Apperyio;
        this.$v = this.Apperyio.vars;
        this.trip_plan_icon = MAIN_MENU_ICONS.TRIP_PLAN;
        this.footprints_icon = 'assets/images/footprint.svg';
        this.chat_icon = 'assets/images/chat.svg';
        this.explore_icon = 'assets/images/travel_explore.svg';
        this.my_location_icon = 'assets/images/my_location.svg';
        this.aioChangeDetector = this.$aio_changeDetector;
    }
}